import * as FiIcons from 'react-icons/fi';

export const qrTypes=[
  {id: 'url',label: 'Website',icon: FiIcons.FiGlobe},
  {id: 'text',label: 'Text',icon: FiIcons.FiType},
  {id: 'email',label: 'Email',icon: FiIcons.FiMail},
  {id: 'phone',label: 'Phone',icon: FiIcons.FiPhone},
  {id: 'wifi',label: 'Wi-Fi',icon: FiIcons.FiWifi},
  {id: 'contact',label: 'Contact',icon: FiIcons.FiUser},
  {id: 'event',label: 'Event',icon: FiIcons.FiCalendar},
  {id: 'location',label: 'Location',icon: FiIcons.FiMapPin},
  {id: 'crypto',label: 'Crypto',icon: FiIcons.FiDollarSign},
  {id: 'social',label: 'Social',icon: FiIcons.FiShare2},
  {id: 'file',label: 'File',icon: FiIcons.FiFile},
  {id: 'more',label: 'More',icon: FiIcons.FiGrid}
];

export const presets=[
  {name: 'Neon',foreground: '#10102f',background: '#e6e6ff',accent: '#a855f7'},
  {name: 'Tropical',foreground: '#073b36',background: '#d7fff2',accent: '#00cba9'},
  {name: 'Solar',foreground: '#4a160b',background: '#fff0c2',accent: '#ff6b24'},
  {name: 'Cobalt',foreground: '#071d55',background: '#d9f2ff',accent: '#168bff'}
];

export function parseContent(value,defaults={}) {
  try {
    const parsed=JSON.parse(value);
    return parsed && typeof parsed==='object' ? {...defaults,...parsed} : defaults;
  } catch {
    return {...defaults,value};
  }
}

function encode(value) {
  return encodeURIComponent(value || '');
}

export function buildPayload(type,value) {
  const data=parseContent(value,{value});
  if (type==='url') {
    const url=data.value || '';
    return url && !/^([a-z]+:)?\/\//i.test(url) ? `https://${url}` : url;
  }
  if (type==='text') return data.value || '';
  if (type==='email') {
    return `mailto:${data.email || ''}?subject=${encode(data.subject)}&body=${encode(data.body)}`;
  }
  if (type==='phone') return `tel:${data.value || ''}`;
  if (type==='wifi') {
    return `WIFI:T:${data.security || 'WPA'};S:${data.ssid || ''};P:${data.password || ''};H:${data.hidden ? 'true' : 'false'};;`;
  }
  if (type==='contact') {
    return [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `FN:${data.name || ''}`,
      `TEL:${data.phone || ''}`,
      `EMAIL:${data.email || ''}`,
      `ORG:${data.company || ''}`,
      `NOTE:${data.note || ''}`,
      'END:VCARD'
    ].join('\n');
  }
  if (type==='event') {
    return [
      'BEGIN:VEVENT',
      `SUMMARY:${data.title || ''}`,
      `DTSTART:${(data.start || '').replace(/[-:]/g,'')}`,
      `LOCATION:${data.location || ''}`,
      `DESCRIPTION:${data.description || ''}`,
      'END:VEVENT'
    ].join('\n');
  }
  if (type==='location') return `geo:${data.latitude || '0'},${data.longitude || '0'}?q=${encode(data.label)}`;
  if (type==='crypto') return `${data.network || 'bitcoin'}:${data.address || ''}?amount=${encode(data.amount)}&message=${encode(data.memo)}`;
  if (type==='social') return data.profile || '';
  if (type==='file') return data.url || '';
  return data.value || '';
}